import { TWhatsNewNotification } from 'lendingApi/whatsNew';
import { MainItem } from './MainItem/MainItem';
import styles from './MainList.module.css';

type TProps = {
  data: TWhatsNewNotification[];
};

export const MainList = ({ data }: TProps) => {
  return (
    <div className={styles.content}>
      {data.map((notification) => (
        <MainItem key={notification.id} data={notification} />
      ))}
    </div>
  );
};
